module.exports = __webpack_public_path__ + "img/c1-tit2.655ed245.png";